import { z } from "zod";
import { TaxonomyDtoSchema } from "./TaxonomyDto";

export const RequestFileDtoSchema = z.object({
    name: z.string().nullish(),
    extension: z.string().nullish(),
    size: z.number(),
    taxonomyId: z.number().nullish(),
    taxonomy: z.lazy(() => TaxonomyDtoSchema).nullish(),
    fileDeferred: z.any(), // Added from FE
    clicked: z.boolean().nullish(), // Added from FE
    uploadCompleted: z.boolean().nullish(), // Added from FE
    icon: z.string().nullish(), // Added from FE
    id: z.string().nullish(), // Added from FE
    iconUrl: z.string().nullish(), // Added from FE
    iconTooltip: z.string().nullish(), // Added from FE
    iconText: z.string().nullish(), // Added from FE
    progress: z.number().nullish(), // Added from FE
    error: z.any(), // Added from FE
    sessionId: z.string().nullish(), // Added from FE
    requestTypeId: z.number().nullish(), // Added from FE
    requestId: z.string().nullish(), // Added from FE
    type: z.string().nullish(), // Added from FE
});

export type RequestFileDto = z.infer<typeof RequestFileDtoSchema>;